import { axiosInstance } from "../../../config/api/Axios";

export const getSharedView = async (code, view, id, version) =>
    axiosInstance.get("/data-accesses", { params: { code, view, id, v: version } });

export const generateSharedToken = async (type, param) =>
    axiosInstance.post("/lab/data-access-tokens", { type, param });
